import moment from "moment";
import React from "react";

const RightChatBox = ({ sender, updated_at, message, type }) => {
  const isDocType = type === "doc";
  return (
    <div className=" flex flex-col space-y-2 ">
      <div className="flex items-center space-x-2 justify-end">
        <div className="bg-right-chat size-10 flex items-center justify-center rounded-full">
          <img src="/chat-user.svg" alt="chat-user-svg" className="size-5" />
        </div>
        <p className="font-20-30-500">{sender.split('@')[0]}</p>
      </div>
      <div className=" border-radius-right-box p-3 ml-8 bg-white">
        {isDocType ? (
          <div className="flex space-x-4 items-center">
            <img src="/folder.svg" alt="folder-svg" className="size-76" />
            <img src="/download.svg" alt="download-svg" className="w-24 h-19" />
            <a
              href={message && message.props && message.props.children}
              target="_blank"
              rel="noopener noreferrer"
              className="font-17-23-400 poppins-regular text-table-header "
            >
              Download
            </a>
          </div>
        ) : (
          <p className="font-17-23-400 flex poppins-regular text-table-header ">
            {message}
          </p>
        )}
        <p className="chat-timestamp flex justify-end ">
        {moment.utc(updated_at).fromNow()}
        </p>
      </div>
    </div>
  );
};

export default RightChatBox;
